import { render } from "./DashboardCoordinatorView.vue?vue&type=template&id=15862221&scoped=true"
import script from "./DashboardCoordinatorView.vue?vue&type=script&lang=js"
export * from "./DashboardCoordinatorView.vue?vue&type=script&lang=js"

import "./DashboardCoordinatorView.vue?vue&type=style&index=0&id=15862221&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15862221"]])

export default __exports__